import { render, staticRenderFns } from "./AddMetaField.vue?vue&type=template&id=4529449a&scoped=true&"
import script from "./AddMetaField.vue?vue&type=script&lang=js&"
export * from "./AddMetaField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4529449a",
  null
  
)

export default component.exports